import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4087b0c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-slim d-flex flex-column gap-3 w-100 mb-4" }
const _hoisted_2 = { class: "d-flex flex-wrap align-items-center gap-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1))
const _hoisted_6 = { class: "ms-auto flex-grow-1 d-flex align-items-center justify-content-end gap-2" }
const _hoisted_7 = { class: "bg-light rounded p-4" }
const _hoisted_8 = { class: "adv-grid" }
const _hoisted_9 = {
  key: 0,
  class: "fv-row"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Người phụ trách", -1))
const _hoisted_11 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Nhóm phụ trách", -1))
const _hoisted_13 = { class: "fv-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Tỉnh/TP (trường L12)", -1))
const _hoisted_15 = { class: "fv-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Trường L12", -1))
const _hoisted_17 = { class: "fv-row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Dữ liệu hồ sơ", -1))
const _hoisted_19 = { class: "fv-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Điểm Bộ GD&ĐT", -1))
const _hoisted_21 = { class: "fv-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Ngành", -1))
const _hoisted_23 = { class: "fv-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Minh chứng", -1))
const _hoisted_25 = {
  key: 0,
  class: "fv-row"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Người phụ trách", -1))
const _hoisted_27 = {
  key: 1,
  class: "fv-row"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Nhóm phụ trách", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex-wrap align-items-center gap-3", _ctx.selecting ? 'd-none' : 'd-flex'])
      }, [
        _renderSlot(_ctx.$slots, "search", {}, undefined, true),
        _createElementVNode("div", null, [
          (_ctx.isProfile)
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                class: "form-select-solid",
                "popper-class": "filter-slim-dd",
                style: {"width":"170px"},
                placeholder: "Trạng thái",
                modelValue: _ctx.data.status,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.status) = $event)),
                filterable: true,
                onChange: _ctx.applyFilterDebounced
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Trạng thái —",
                    value: "all"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Mới",
                    value: "new"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Đã xác thực",
                    value: "verified"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Đang xem xét",
                    value: "reviewing"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Chưa hoàn tất",
                    value: "processing"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Không hợp lệ",
                    value: "rejected"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Từ chối",
                    value: "denied"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]))
            : (_openBlock(), _createBlock(_component_el_select, {
                key: 1,
                class: "form-select-solid",
                "popper-class": "filter-slim-dd",
                style: {"width":"170px"},
                placeholder: "Tình trạng",
                modelValue: _ctx.data.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.status) = $event)),
                filterable: true,
                onChange: _ctx.applyFilterDebounced
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Tình trạng —",
                    value: "all"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Đã tốt nghiệp",
                    value: "graduated"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Chứng nhận TNTT",
                    value: "temp_graduated"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Chưa tốt nghiệp",
                    value: "not_graduated"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Chưa xác định",
                    value: "null"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]))
        ]),
        (!_ctx.isProfile && !_ctx.hideHasAmount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_select, {
                class: "form-select-solid",
                "popper-class": "filter-slim-dd",
                style: {"width":"160px"},
                modelValue: _ctx.data.hasAmount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.hasAmount) = $event)),
                onChange: _ctx.applyFilterDebounced
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Hồ sơ nộp —",
                    value: "Tất cả"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Có hồ sơ",
                    value: "Có"
                  }),
                  _createVNode(_component_el_option, {
                    label: "Chưa có hồ sơ",
                    value: "Không"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isProfile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_select, {
                class: "form-select-solid",
                "popper-class": "filter-slim-dd",
                style: {"width":"190px"},
                placeholder: "Phương thức",
                modelValue: _ctx.dataFilterProfile.method,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataFilterProfile.method) = $event)),
                filterable: true,
                onChange: _ctx.applyFilterDebounced
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethods, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.value === 0 ? '— Phương thức —' : item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            "popper-class": "filter-slim-dd",
            style: {"width":"160px"},
            placeholder: "Tháng tạo",
            modelValue: _ctx.data.month,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.month) = $event)),
            filterable: true,
            onChange: _ctx.applyFilterDebounced
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "— Tháng tạo —",
                value: 0
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                return _createVNode(_component_el_option, {
                  key: m,
                  label: `Tháng ${m}`,
                  value: m
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-sm", _ctx.showAdvanced ? 'btn-primary' : 'btn-light-primary']),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAdvanced = !_ctx.showAdvanced))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["bi me-1", _ctx.showAdvanced ? 'bi-funnel-fill' : 'bi-funnel'])
          }, null, 2),
          _createTextVNode(" Lọc nâng cao "),
          _createElementVNode("i", {
            class: _normalizeClass(["bi ms-1 fs-8", _ctx.showAdvanced ? 'bi-chevron-up' : 'bi-chevron-down'])
          }, null, 2)
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
          title: "Đặt lại toàn bộ bộ lọc"
        }, [
          _hoisted_5,
          _createTextVNode("Đặt lại ")
        ])
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
      ])
    ]),
    _createVNode(_Transition, { name: "adv-expand" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (!_ctx.isProfile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.infUser?.role == 1 || _ctx.infUser?.role == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            "popper-class": "filter-slim-dd",
                            style: {"width":"100%"},
                            placeholder: "Người phụ trách",
                            modelValue: _ctx.data.assignee,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.assignee) = $event)),
                            filterable: true,
                            onChange: _ctx.applyFilterDebounced
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrUsersAssign, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.infUser?.role == 1 || _ctx.infUser?.role == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            "popper-class": "filter-slim-dd",
                            style: {"width":"100%"},
                            placeholder: "Nhóm phụ trách",
                            modelValue: _ctx.data.groupAssignee,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.groupAssignee) = $event)),
                            filterable: true,
                            onChange: _ctx.applyFilterDebounced
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrGroupsAssign, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        placeholder: "Chọn Tỉnh/Thành phố",
                        modelValue: _ctx.data.class12ProvinceId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.class12ProvinceId) = $event)),
                        filterable: true,
                        onChange: _cache[10] || (_cache[10] = ($event: any) => {_ctx.getSchool(_ctx.data.class12ProvinceId); _ctx.applyFilterDebounced()})
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrProvinceForSchool, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        placeholder: "Chọn trường",
                        modelValue: _ctx.data.class12SchoolId,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.class12SchoolId) = $event)),
                        filterable: true,
                        onChange: _ctx.applyFilterDebounced
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrSchool, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        modelValue: _ctx.dataIssue,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dataIssue) = $event)),
                        onChange: _ctx.applyFilterDebounced
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tất cả",
                            value: 0
                          }),
                          _createVNode(_component_el_option, {
                            label: "Lỗi ngành (chưa chọn / đã xoá)",
                            value: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Trùng CCCD",
                            value: 2
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        modelValue: _ctx.data.bgdsync,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.bgdsync) = $event)),
                        onChange: _ctx.applyFilterDebounced
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tất cả",
                            value: ""
                          }),
                          _createVNode(_component_el_option, {
                            label: "Đã khớp học bạ",
                            value: "transcript"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Đã khớp điểm TN",
                            value: "graduationscore"
                          }),
                          _createVNode(_component_el_option, {
                            label: "Chưa khớp gì với Bộ",
                            value: "none"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isProfile)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        placeholder: "Chọn ngành",
                        modelValue: _ctx.dataFilterProfile.major,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dataFilterProfile.major) = $event)),
                        filterable: true,
                        onChange: _ctx.applyFilterDebounced
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        modelValue: _ctx.data.nofile,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.data.nofile) = $event)),
                        onChange: _ctx.applyFilterDebounced
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tất cả",
                            value: 0
                          }),
                          _createVNode(_component_el_option, {
                            label: "Chưa có file minh chứng",
                            value: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Có file minh chứng",
                            value: 2
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    (_ctx.infUser?.role == 1 || _ctx.infUser?.role == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            "popper-class": "filter-slim-dd",
                            style: {"width":"100%"},
                            placeholder: "Người phụ trách",
                            modelValue: _ctx.data.assignee,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.data.assignee) = $event)),
                            filterable: true,
                            onChange: _ctx.applyFilterDebounced
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrUsersAssign, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.infUser?.role == 1 || _ctx.infUser?.role == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _hoisted_28,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            "popper-class": "filter-slim-dd",
                            style: {"width":"100%"},
                            placeholder: "Nhóm phụ trách",
                            modelValue: _ctx.data.groupAssignee,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.data.groupAssignee) = $event)),
                            filterable: true,
                            onChange: _ctx.applyFilterDebounced
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrGroupsAssign, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "advanced", {}, undefined, true)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showAdvanced && !_ctx.selecting]
        ])
      ]),
      _: 3
    })
  ]))
}